module.exports = __webpack_public_path__ + "img/xnh.7249f0ab.svg";